"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.useCreateTask = void 0;
var react_1 = __importDefault(require("react"));
var omni_continuity_1 = require("@hiyllo/omni-continuity");
var CreateTaskBP = __importStar(require("@hiyllo/omni-common/src/blueprints/tasks/create-task-item"));
var task_item_1 = require("@hiyllo/omni-common/src/types/tasks/task-item");
function useCreateTask(opts) {
    var _this = this;
    var _a = react_1["default"].useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var client = (0, omni_continuity_1.useClient)();
    var createTaskMutation = client.useMutation(CreateTaskBP);
    var createTask = react_1["default"].useCallback(function (input) { return __awaiter(_this, void 0, void 0, function () {
        var title, projectUUID, res;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    title = input.title, projectUUID = input.projectUUID;
                    opts.onErrorMessage(null);
                    if (title.length < 1) {
                        opts.onErrorMessage("Add a title");
                        throw new Error("Add a title");
                    }
                    if (projectUUID == null) {
                        opts.onErrorMessage("Select a project");
                        throw new Error("Select a project");
                    }
                    setIsLoading(true);
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            var performCreateTask = function (ignoreSimilarTaskWarning) {
                                void createTaskMutation.call(__assign(__assign({}, input), { type: task_item_1.TaskType.task, ignoreSimilarTaskWarning: ignoreSimilarTaskWarning })).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
                                    var shouldContinue;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                if (!(res.status === "similar-task-warning")) return [3 /*break*/, 2];
                                                return [4 /*yield*/, opts.onSimilarTaskWarning(res.task)];
                                            case 1:
                                                shouldContinue = _a.sent();
                                                if (shouldContinue) {
                                                    performCreateTask(true);
                                                }
                                                else {
                                                    resolve(null);
                                                }
                                                return [3 /*break*/, 3];
                                            case 2:
                                                resolve({ taskUUID: res.taskUUID });
                                                _a.label = 3;
                                            case 3: return [2 /*return*/];
                                        }
                                    });
                                }); })["catch"](reject);
                            };
                            performCreateTask(false);
                        })];
                case 1:
                    res = _a.sent();
                    setIsLoading(false);
                    return [2 /*return*/, res];
            }
        });
    }); }, [opts.onErrorMessage, opts.onSimilarTaskWarning]);
    return {
        createTask: createTask,
        isLoading: isLoading
    };
}
exports.useCreateTask = useCreateTask;
